// CONCEPT: stock by warehouse on a Classic view parts row (#1875, #1880) - "Main 4 · North 2"
//          inline under the row's availability, the way RockAuto shows a warehouse split.
//
//          The figures are the ones the batched stock-and-price request already answered
//          (whs/get_inventory_and_pricing, warehouse_inventory_by_location), painted by
//          applyAvailabilityResults() in partials/product-browse.js into any card that carries a
//          [data-stock-by-location] slot - only the Classic rows do. Nothing here asks anything.
//
//          Only locations holding stock are listed, in the order the warehouse answered them;
//          stock_display_cap applies to each figure the way it does in the Check Stock table
//          (outputLocations()). The caller passes an empty set when show_stock is off, so the row
//          shows availability words and never a number.
//
// USE:     paintStockByLocation(slotElement, item.warehouse_inventory_by_location, stockDisplayCap)

/**
 * @param {Record<string, number|string>|null|undefined} warehouses
 * @param {number} cap stock_display_cap; 0 or less for none
 * @returns {Array<{label: string, qty: string}>}
 */
export function stockByLocation(warehouses, cap) {
    var out = [];
    if (!warehouses || typeof warehouses !== 'object') {
        return out;
    }
    Object.keys(warehouses).forEach(function (label) {
        var qty = parseInt(warehouses[label], 10);
        if (isNaN(qty) || qty <= 0) {
            return;
        }
        out.push({ label: label, qty: cap > 0 && qty > cap ? cap + '+' : String(qty) });
    });

    return out;
}

/**
 * @param {HTMLElement} slot
 * @param {Record<string, number|string>|null|undefined} warehouses
 * @param {number} cap
 */
export function paintStockByLocation(slot, warehouses, cap) {
    if (!slot) {
        return;
    }
    slot.textContent = '';
    stockByLocation(warehouses, cap).forEach(function (location) {
        var entry = document.createElement('span');
        entry.className = 'classic-part__location';
        entry.setAttribute('data-location', location.label);
        entry.textContent = location.label + ' ' + location.qty;
        slot.appendChild(entry);
    });
}
